export enum UserRole {
  ADMIN = 'ADMIN',
  ORG_ADMIN = 'ORG_ADMIN',
  USER = 'USER',
  GRANT_AI_USER = 'GRANT_AI_USER',
  GRANT_AI_ADMIN = 'GRANT_AI_ADMIN'
}

export const getUserRoles = (isPublic: boolean): UserRole[] => {
  if (isPublic === true)
    return [UserRole.GRANT_AI_USER, UserRole.GRANT_AI_ADMIN];

  return [UserRole.ORG_ADMIN, UserRole.USER];
}
